export enum SUPPORTED_LANG {
    DE = 'de',
    EN = 'en',
    ES = 'es',
    FI = 'fi',
    FR = 'fr',
    IT = 'it',
    LT = 'lt',
    NL = 'nl',
    PL = 'pl',
    PT = 'pt',
    UK = 'uk',
    RU = 'ru',
}
